<template>
  <div style="position: relative;margin-top: 20px;">
    <!-- <div :class="`slogen ${path}`">
      China International Medical Foundation
    </div> -->
    <div class="f_circle"></div>
    <img class="logo_img"
         src="../assets/img/logo_white.png">
    <div id="footer"
         class="container-fluid">
      <div class="container">
        <div class="footer_info">
          <!-- <div class="footer_menu_list">
            <div class="footer_menu_list_item"
                 :style="{display: `${item.children.length == 0 ? 'inline-block' : ''}`}"
                 v-for="item in menu"
                 :key="item.id">
              <a class="footer_menu_list_item_parent"
                 @click="handleClick(item, '1')"
                 rel="opener">{{ item.name }}</a>
              <div class="footer_menu_list_item_child"
                   v-if="item.children && item.children.length > 0">
                <a v-for="ele in item.children"
                   @click="handleClick(ele)"
                   :key="ele.id"
                   rel="opener"
                   target="_blank"
                   :to="item.path">{{ ele.name }}</a>
              </div>
            </div>
          </div> -->

          <div class="footer_text">
            <div class="footer_info_text">
              地址: 北京市东城区东四西大街42号<br>
              邮编: 100710<br>
              电话: 010-51321604<br>
              邮箱: cimf@cimf.org.cn
            </div>
            <div class="footer_en hidden-sm hidden-xs">
              <span style="text-align: left;display: inline-block;">
                Address: 42 Dongsi Xidajie,Beijing<br>
                Postal Code: 100710<br>
                Tel: 010-51321604<br>
                Email: cimf@cimf.org.cn
              </span>
            </div>

            <div style="display: flex;justify-content: space-between;"
                 class="wei_img">
              <div class="hidden-sm hidden-xs">&nbsp;</div>
              <div style="flex: 2;">
                <img class="weixin"
                     src="../assets/img/weixin.png">
                <div class="w_text">微信公众号</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer_img_con  hidden-sm hidden-xs">
          <div class="copy">
            2022 中华国际医学交流基金会 CIMF 版权所有 <br />
            <a href="https://beian.miit.gov.cn/"
               target="_blank">
              京ICP备06000352号
            </a>
          </div>

        </div>
        <div class="copy visible-xs visible-sm">
          2022 中华国际医学交流基金会 CIMF 版权所有 <br />

          <a href="https://beian.miit.gov.cn/"
             target="_blank">
            京ICP备06000352号
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex"
  export default {
    name: "Footer",
    data () {
      return {
        menu: [],
        path: "home"
      }
    },
    computed: {
      ...mapGetters(["menuData"])
    },
    watch: {
      $route (to, from) {
        if (to.path == "/home") {
          this.path = "home"
        } else {
          this.path = ""
        }
      }
    },
    created () {
      let menu = JSON.parse(JSON.stringify(this.menuData))
      menu.map((item, i) => {
        if (item.id == 1 || item.id == 9) {
          menu.splice(i, 1)
        }
      })
      for (var x in menu) {
        menu[x].path == "/regulation" ? menu.push(menu.splice(x, 1)[0]) : 0
        menu[x].path == "/party_work" ? menu.push(menu.splice(x, 1)[0]) : 0
      }
      this.menu = menu
    },
    methods: {
      handleClick (item, type) {
        if (type) {
          if (item.children && item.children.length > 0) {
            sessionStorage.setItem("childId", item.children[0].id)
          }
        } else {
          sessionStorage.setItem("childId", item.id)
        }
        // 默认是替换了当前的窗口
        let text = this.$router.resolve({
          path: item.path
        })
        // 打开一个新的页面
        window.open(text.href, "_blank")
      }
    }
  }
</script>
<style lang="scss">
  .f_circle {
    background: #17457d;
    height: 70px;
    width: 140px;
    margin: 0 auto -1px;
    border-radius: 70px 70px 0 0;
  }
  #footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: url(../assets/img/footer_bg.png) no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    text-align: center;
    position: relative;
    // margin-top: 20px;
    .footer_info {
      padding: 200px 0 40px;
      display: flex;
      align-items: center;
      .footer_menu_list {
        display: flex;
        flex: 4;
        flex-wrap: nowrap;
        justify-content: space-between;
        .footer_menu_list_item + .footer_menu_list_item {
          margin-left: 16px;
        }
        .footer_menu_list_item a {
          display: block;
          color: rgba($color: #fff, $alpha: 0.9);
          text-decoration: none;
          font-weight: 600;
          cursor: pointer;
        }
        .footer_menu_list_item_parent:hover {
          font-weight: bold;
          color: rgba($color: #fff, $alpha: 1);
        }
        .footer_menu_list_item {
          text-align: left;
          line-height: 30px;
        }
        .footer_menu_list_item_parent {
          font-weight: 600;
          font-size: 14px;
          border-bottom: 1px solid rgba($color: #fff, $alpha: 0.8);
          margin-bottom: 10px;
        }
        .footer_menu_list_item_child a {
          font-size: 13px;
          color: rgba($color: #fff, $alpha: 0.6);
          text-decoration: none;
          font-weight: normal;
        }
        .footer_menu_list_item_child a:hover {
          font-weight: bold;
          color: rgba($color: #fff, $alpha: 0.9);
        }
      }
      .footer_img {
        // display: flex;
        flex: 1;
        // align-items: baseline;
        // text-align: right;
        .footer_img_con {
          display: flex;
          justify-content: space-around;
          align-items: center;
          img {
            width: 160px;
            height: 160px;
            object-fit: contain;
          }
          .wei_img {
            // margin-right: 40px;
            // margin: 0 auto;
          }
          .w_text {
            margin-top: 20px;
            text-align: center;
          }
        }
      }
      .weixin {
        width: 110px;
        height: 110px;
      }
    }
    .footer_text {
      width: 85%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      text-align: left;
      font-size: 14px;
      line-height: 24px;
      // flex: 1;
      color: rgba($color: #fff, $alpha: 0.6);
      // padding: 30px 0;
      // border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
      justify-content: space-around;
      .footer_en {
        text-align: center;
        // margin-top: 10px;
      }
      div {
        flex: 1;
        img {
          width: 160px;
          height: 160px;
          object-fit: contain;
          margin: 0 auto;
        }
        .w_text {
          margin-top: 10px;
          text-align: center;
        }
      }
      div.footer_info_text {
        padding-top: 10px;
      }
      div.footer_en {
        padding-top: 18px;
      }
    }
    .footer_img_con {
      // align-items: bottom;
      .copy {
        padding-top: 0;
        padding-bottom: 20px;
      }
    }
  }
  .logo_img {
    width: 220px;
    height: 220px;
    top: 80px;
    left: 50%;
    margin-left: -110px;
    margin-top: -110px;
    // margin: auto;
    position: absolute;
    z-index: 9;
  }
  .copy {
    // border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
    color: rgba($color: #fff, $alpha: 0.6);
    text-align: center;
    line-height: 24px;
    // font-size: 12px;
    padding: 20px 0;
    a {
      color: rgba($color: #fff, $alpha: 0.6);
      &:hover {
        color: rgba($color: #fff, $alpha: 0.6);
      }
    }
  }

  /* 媒体查询（手机） */
  @media screen and (max-width: 998px) {
    .container-fluid {
      padding: 0 10px;
    }
    .f_circle {
      background: #17457d;
      height: 50px;
      width: 100px;
      margin: 0 auto;
      border-radius: 50px 50px 0 0;
    }
    #footer {
      margin-top: 0;
      padding-top: 120px;
      .footer_info {
        display: flex;
        padding: 0 0 10px;
        // flex-direction: row-reverse;
        align-items: center;
        .footer_menu_list {
          display: none;
        }
        .w_text {
          font-size: 13px;
        }
        .footer_img {
          flex: 1;
          justify-content: right;
          .w_text {
            font-size: 13px;
          }
        }
      }
      .footer_text {
        font-size: 13px;
        color: #fff;
        flex: 2;
        div {
          flex: unset;
        }
        .copy {
          text-align: left;
        }
        .footer_info_text {
          flex: 2;
        }
      }
    }
    .logo_img {
      width: 160px;
      height: 160px;
      top: 55px;
      left: 50%;
      margin-left: -80px;
      margin-top: -80px;
    }
    .copy {
      font-size: 13px;
    }
  }
  @media (min-width: 767px) and (max-width: 997px) {
    #footer {
      .footer_info {
        width: 65%;
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: 1279px) {
    #footer {
      .footer_info {
        .footer_menu_list {
          flex: none;
        }
      }
      .footer_img {
        flex: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterNew.vue